import type { Repub } from '@cx-modules/constants';

export type NonPlusAuthUrlsConfig = {
  privacyPolicyUrl: (repubPath: string) => string;
  termsAndConditionsUrl: (repubPath: string) => string;
};

const DEFAULT_NON_PLUS_AUTH_URLS: NonPlusAuthUrlsConfig = {
  privacyPolicyUrl: (repubPath: string) => `${repubPath}/privacy`,
  termsAndConditionsUrl: (repubPath: string) => `${repubPath}/terms-and-conditions`,
};

const IT_NON_PLUS_AUTH_URLS: NonPlusAuthUrlsConfig = {
  privacyPolicyUrl: (repubPath: string) => `${repubPath}/informativa-privacy`,
  termsAndConditionsUrl: (repubPath: string) => `${repubPath}/termini-e-condizioni`,
};

const BR_NON_PLUS_AUTH_URLS: NonPlusAuthUrlsConfig = {
  privacyPolicyUrl: (repubPath: string) => `${repubPath}/politicas-cookies-privacidade`,
  termsAndConditionsUrl: (repubPath: string) => `${repubPath}/termos-e-condicoes`,
};

const CO_NON_PLUS_AUTH_URLS: NonPlusAuthUrlsConfig = {
  privacyPolicyUrl: (repubPath: string) => `${repubPath}/cookies`,
  termsAndConditionsUrl: (repubPath: string) => `${repubPath}/terminos-y-condiciones`,
};

const ES_NON_PLUS_AUTH_URLS: NonPlusAuthUrlsConfig = {
  privacyPolicyUrl: (repubPath: string) => `${repubPath}/privacidad-politica-de-cookies`,
  termsAndConditionsUrl: (repubPath: string) => `${repubPath}/terminos-y-condiciones`,
};

const PT_NON_PLUS_AUTH_URLS: NonPlusAuthUrlsConfig = {
  privacyPolicyUrl: (repubPath: string) => `${repubPath}/politica-cookies-privacidade`,
  termsAndConditionsUrl: (repubPath: string) => `${repubPath}/termos-condicoes`,
};

const FR_NON_PLUS_AUTH_URLS: NonPlusAuthUrlsConfig = {
  privacyPolicyUrl: (repubPath: string) => `${repubPath}/cookies`,
  termsAndConditionsUrl: (repubPath: string) => `${repubPath}/termes-et-conditions`,
};

const SE_NON_PLUS_AUTH_URLS: NonPlusAuthUrlsConfig = {
  privacyPolicyUrl: (repubPath: string) => `${repubPath}/privacy`,
  termsAndConditionsUrl: (repubPath: string) => `${repubPath}/terms`,
};

const ZA_NON_PLUS_AUTH_URLS: NonPlusAuthUrlsConfig = {
  privacyPolicyUrl: (repubPath: string) => `${repubPath}/privacy`,
  termsAndConditionsUrl: (repubPath: string) => `${repubPath}/terms`,
};

const DE_NON_PLUS_AUTH_URLS: NonPlusAuthUrlsConfig = {
  privacyPolicyUrl: (repubPath: string) => `${repubPath}/datenschutzrichtlinie`,
  termsAndConditionsUrl: (repubPath: string) => `${repubPath}/nutzungsbedingungen`,
};

const KE_NON_PLUS_AUTH_URLS: NonPlusAuthUrlsConfig = {
  privacyPolicyUrl: (repubPath: string) => `${repubPath}/cookies`,
  termsAndConditionsUrl: (repubPath: string) => `${repubPath}/terms-and-conditions`,
};

const NG_NON_PLUS_AUTH_URLS: NonPlusAuthUrlsConfig = {
  privacyPolicyUrl: (repubPath: string) => `${repubPath}/cookies`,
  termsAndConditionsUrl: (repubPath: string) => `${repubPath}/terms-and-conditions`,
};

const NZ_NON_PLUS_AUTH_URLS: NonPlusAuthUrlsConfig = {
  privacyPolicyUrl: (repubPath: string) => `${repubPath}/privacy`,
  termsAndConditionsUrl: (repubPath: string) => `${repubPath}/terms`,
};

export const NON_PLUS_AUTH_URLS_CONFIG: Record<Repub, NonPlusAuthUrlsConfig> = {
  AU: DEFAULT_NON_PLUS_AUTH_URLS,
  BR: BR_NON_PLUS_AUTH_URLS,
  CA: DEFAULT_NON_PLUS_AUTH_URLS,
  CO: CO_NON_PLUS_AUTH_URLS,
  CX: DEFAULT_NON_PLUS_AUTH_URLS,
  DE: DE_NON_PLUS_AUTH_URLS,
  DK: DEFAULT_NON_PLUS_AUTH_URLS,
  ES: ES_NON_PLUS_AUTH_URLS,
  FR: FR_NON_PLUS_AUTH_URLS,
  GZ: DEFAULT_NON_PLUS_AUTH_URLS,
  IN: DEFAULT_NON_PLUS_AUTH_URLS,
  IT: IT_NON_PLUS_AUTH_URLS,
  KE: KE_NON_PLUS_AUTH_URLS,
  NG: NG_NON_PLUS_AUTH_URLS,
  NL: DEFAULT_NON_PLUS_AUTH_URLS,
  NZ: NZ_NON_PLUS_AUTH_URLS,
  OC: DEFAULT_NON_PLUS_AUTH_URLS,
  PT: PT_NON_PLUS_AUTH_URLS,
  SE: SE_NON_PLUS_AUTH_URLS,
  SM: DEFAULT_NON_PLUS_AUTH_URLS,
  US: DEFAULT_NON_PLUS_AUTH_URLS,
  WS: DEFAULT_NON_PLUS_AUTH_URLS,
  XX: DEFAULT_NON_PLUS_AUTH_URLS,
  ZA: ZA_NON_PLUS_AUTH_URLS,
};
